import React from "react";
import { useTranslation } from "react-i18next";
import wcommercemark from "../../assets/images/wcommerce-mark.png";
import Razorpaytrusted from "../../assets/images/razorpay-trusted.svg";
const Navfooter = ({ gstin }) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="mt-[6px] mx-[14px] mb-[16px] border-t border-[#E8EAF0] pt-[12px]">
        <div className="flex items-center gap-[7px] text-[10.5px] text-[#545454] mt-[7px]">
          <span className="w-[18px] h-[18px] rounded-[5px] bg-[#4862EE] overflow-hidden flex-none">
            <img
              src={wcommercemark}
              alt="wcommerce-mark"
              className="w-full h-full block"
            />
          </span>{" "}
          {t("navFooter.fulfilledBy")}
        </div>
        <div className="flex items-center gap-[7px] text-[10.5px] text-[#545454] mt-[7px]">
          <span className="inline-flex bg-white border border-[#E8EAF0] rounded-[5px] px-[6px] py-[3px]">
            <img
              src={Razorpaytrusted}
              alt={t("navFooter.razorpayAlt")}
              className="h-[15px] block"
            />
          </span>
          {t("navFooter.securePayments")}
        </div>
        {gstin ? (
          <div className="text-[10px] text-[#707078] mt-[8px]">
            <span className="text-[#2C2C2C] font-[500]">
              {t("navFooter.gstRegistered")}
            </span>{" "}
            · GSTIN {gstin}
          </div>
        ) : null}
      </div>
    </>
  );
};
export default Navfooter;
